<template>
  <div>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
              <h5 class="float-left"><i class='fa fa-search'></i> Search</h5>
          </b-card-header>
          <b-card-body>
            <b-form>
              <b-row>
                <b-col sm="3">
                  <label class="mr-sm-2" for="sUsername">Username </label>
                  <b-input id="sUsername" type="text" placeholder="" v-model.trim="sUsername"></b-input>
                </b-col>
                <b-col sm="3">
                  <label class="mr-sm-2" for="sTicket">Ticket </label>
                  <b-input id="sTicket" type="text" placeholder="" v-model.trim="sTicket"></b-input>
                </b-col>
                <b-col sm="3">
                  <label for="sCardId">Scratch Card&nbsp;&nbsp;</label>
                  <b-form-select id="sCardId" :plain="false" v-model="sCardId">
                    <option :value="null">Please select</option>
                    <option v-for="s in cardListOption" :key="`Status-${s.Id}`" :value="s.Id">{{ s.Name }}</option>
                  </b-form-select>
                </b-col>
                <b-col sm="3">
                  <label for="sRewardId">Reward&nbsp;&nbsp;</label>
                  <b-form-select id="sRewardId" :plain="false" v-model="sRewardId">
                    <option :value="null">Please select</option>
                    <option v-for="s in rewardOption" :key="`Status-${s.Id}`" :value="s.Id">{{ s.Name }} - {{ getAmount(s.Amount, s.Type) }}</option>
                  </b-form-select>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="3">
                  <label for="sStatus">Status&nbsp;&nbsp;</label>
                  <b-form-select id="sStatus" :plain="false" v-model="sStatus">
                    <option :value="null">Please select</option>
                    <option v-for="s in status" :key="`Status-${s.Id}`" :value="s.Id">{{ s.label }}</option>
                  </b-form-select>
                </b-col>
                <b-col sm="3">
                  <label class="mr-sm-2" for="sStartTime">Add Time (yyyy/mm/dd 00:00:00) From</label>
                  <b-input id="sStartTime" type="date" placeholder="" v-model.trim="sStartTime"></b-input>
                </b-col>
                <b-col sm="3">
                  <label class="mr-sm-2" for="sEndTime">Add Time (yyyy/mm/dd 23:59:59) To</label>
                  <b-input id="sEndTime" type="date" placeholder="" v-model.trim="sEndTime"></b-input>
                </b-col>
                <b-col sm="3" class="align-self-end">
                  <b-button id="sBtn" variant="primary" @click="search"><i class="fa fa-search"></i> Search</b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-card no-body>
          <b-card-header>
            <h3 class="float-left"><i class='fa fa-tag'></i> Tickets</h3>
          </b-card-header>
          <b-card-body>
            <div class="overflow-auto">
              <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields">
                <template v-slot:cell(Price)="data">
                  {{ getAmount(data.item.Price, data.item.Type) }}
                </template>
                <template v-slot:cell(Status)="data">
                  <b-badge variant="success" v-if="data.item.Status === 0">Created</b-badge>
                  <b-badge variant="danger" v-else-if="data.item.Status === 1">Claimed</b-badge>
                </template>
              </b-table>
            </div>
            <nav>
              <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            </nav>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Events } from '../../../events.js'
import VueNotifications from 'vue-notifications'
const moment = require('moment-timezone')

export default {
  name: 'scratchcard-ticket-table',
  props: {
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      items: [],
      fields: [
        {key: 'Id', label: 'Id'},
        {key: 'CardName', label: 'Scratch Card'},
        {key: 'Ticket', label: 'Ticket'},
        {key: 'Username', label: 'Username'},
        {key: 'Reward', label: 'Reward'},
        {key: 'Price', label: 'Ticket Price'},
        {key: 'WinAmount', label: 'Win Amount'},
        {key: 'Status', label: 'Status'},
        {key: 'AddTime', label: 'Purchase Time'}
      ],
      perPage: 50,
      currentPage: 1,
      rowCount: 0,
      status: [
        {Id: '0', label: 'Created'},
        {Id: '1', label: 'Claimed'}
      ],
      cardListOption: [],
      rewardOption: [],
      sUsername: '',
      sTicket: '',
      sCardId: null,
      sRewardId: null,
      sStatus: null,
      sStartTime: moment().subtract(3, 'days').tz('Asia/Taipei').format('YYYY-MM-DD'),
      sEndTime: moment().tz('Asia/Taipei').format('YYYY-MM-DD')
    }
  },
  watch: {
    currentPage: function (val) {
      this.search()
    }
  },
  methods: {
    getRowCount () {
      return this.rowCount
    },
    getAmount (amount, val) {
      return `${amount} ${(val === 1) ? 'Credits' : (val === 2) ? 'Points' : ''}`
    },
    async search () {
      try {
        Events.$emit('loader')
        let queryStr = `ticket=${this.sTicket}&username=${this.sUsername}&cardId=${this.sCardId || ''}&status=${this.sStatus || ''}&rewardId=${this.sRewardId || ''}&startTime=${this.sStartTime}&endTime=${this.sEndTime}&size=${this.perPage}&page=${this.currentPage}`
        let { data } = await this.$http.get(this.API_ENDPOINT + '/scratchcard/ticket/search?' + queryStr, { headers: { 'Content-Type': 'application/json' } })
        this.items = data.ticket
        this.rowCount = data.rowCount
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    },
    async getCardList () {
      try {
        let { data } = await this.$http.get(this.API_ENDPOINT + '/scratchcard/game/all', { headers: { 'Content-Type': 'application/json' } })
        this.cardListOption = data
        return
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      }
    },
    async getRewardList () {
      try {
        let { data } = await this.$http.get(this.API_ENDPOINT + '/scratchcard/reward/all?type=', { headers: { 'Content-Type': 'application/json' } })
        this.rewardOption = data
        return
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      }
    },
    checkAccessPrivilege (module, title = false) {
      return true
      // if (!module) return true
      // if (title) return (JSON.stringify(this.PRIVILEGE).includes(module))
      // return this.PRIVILEGE.includes(module)
    }
  },
  async created () {
    await this.search()
    await this.getCardList()
    await this.getRewardList()
  }
}
</script>


// WEBPACK FOOTER //
// src/views/scratchcard/tickets/TicketsTable.vue